
export const ThemeController = (isDark) => {
    const body = document.querySelector('body')
    const darkTriller = getComputedStyle(body).getPropertyValue('--dark-triller-color')
    const darkShadow = getComputedStyle(body).getPropertyValue('--dark-box-shadow')
    const darkHint = getComputedStyle(body).getPropertyValue('--dark-hint-color')
    const dark = getComputedStyle(body).getPropertyValue('--dark-color')
    const light = getComputedStyle(body).getPropertyValue('--light-color')
    const lightHint = getComputedStyle(body).getPropertyValue('--light-hint-color')
    const lightTriller = getComputedStyle(body).getPropertyValue('--light-triller-color')
    const lightShadow = getComputedStyle(body).getPropertyValue('--light-box-shadow')

    if (isDark) {
        body.style.setProperty('--main-bg-color', dark);
        body.style.setProperty('--main-bg-triller-color', darkTriller);
        body.style.setProperty('--main-text-color', light);
        body.style.setProperty('--box-shadow', darkShadow);
        body.style.setProperty('--main-hint-color', darkHint);
        body.style.setProperty('--invert', 1);
    } else {
        body.style.setProperty('--main-bg-color', light);
        body.style.setProperty('--main-bg-triller-color', lightTriller);
        body.style.setProperty('--main-text-color', dark);
        body.style.setProperty('--box-shadow', lightShadow);
        body.style.setProperty('--main-hint-color', lightHint);
        body.style.setProperty('--invert', 0);
    }
}


